import {
  KalturaAssetType,
  BookmarkListAction,
  BookmarkAddAction,
  KalturaBookmarkListResponse,
  KalturaBookmarkFilter,
  KalturaBookmark,
  KalturaBookmarkPlayerData,
} from '@kaltura-ott/ott-client-types/api/types';
import { EMPTY, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { kalturaClient } from './kaltura-clent';

/**
 *  Get playback context for player
 *  @param assetId: string
 *  @param position: number
 *  @param playerData: KalturaBookmarkPlayerData
 *  @param assetTypeEqual: KalturaAssetType
 */
export const addBookmark = (
  assetId: string,
  position: number,
  playerData: KalturaBookmarkPlayerData,
  assetTypeEqual = KalturaAssetType.media,
): Observable<boolean> => {
  const action = new BookmarkAddAction({
    bookmark: new KalturaBookmark({
      position,
      id: assetId,
      type: assetTypeEqual,
      playerData,
    }),
  });

  const client = kalturaClient();
  return client.request(action).pipe(
    catchError((error) => {
      return EMPTY;
    }),
  );
};

/**
 *  Get playback context for player
 *  @param assetId
 *  @param assetTypeEqual: KalturaAssetType
 *  @param orderBy: 'POSITION_ASC' | 'POSITION_DESC'
 */
export const getBookmarks = (
  assetId: string | number,
  assetTypeEqual = KalturaAssetType.epg,
  orderBy = 'POSITION_ASC',
): Observable<KalturaBookmarkListResponse> => {
  if (!assetId) {
    return of(new KalturaBookmarkListResponse({ objects: [], totalCount: 0 }));
  }
  const action = new BookmarkListAction({
    filter: new KalturaBookmarkFilter({ assetIdIn: assetId.toString(), assetTypeEqual, orderBy }),
  });

  const client = kalturaClient();
  return client.request(action).pipe(
    catchError((error) => {
      return of(new KalturaBookmarkListResponse({ objects: [], totalCount: 0 }));
    }),
  );
};
